import werk1 from "../assets/werk-1.jpg.asset.json";
import werk2 from "../assets/werk-2.jpg.asset.json";
import werk3 from "../assets/werk-3.jpg.asset.json";
import werk4 from "../assets/werk-4.jpg.asset.json";

const fotos = [
  { url: werk1.url, onderwerp: "een groepenkast aansluiten" },
  { url: werk2.url, onderwerp: "een laadpaal monteren" },
  { url: werk3.url, onderwerp: "spots en verlichting plaatsen" },
  { url: werk4.url, onderwerp: "een storing opsporen" },
];

function hash(slug: string) {
  let n = 0;
  for (let i = 0; i < slug.length; i += 1) n = (n * 31 + slug.charCodeAt(i)) % 100000;
  return n;
}

export function plaatsFoto(slug: string, plaatsNaam: string) {
  const foto = fotos[hash(slug) % fotos.length]!;
  return {
    url: foto.url,
    alt: `Erkende elektricien in ${plaatsNaam} bezig met ${foto.onderwerp}`,
  };
}

const dienstIndex: Record<string, number> = {
  groepenkast: 0,
  "elektra-aanleggen": 0,
  "laadpaal-installeren": 1,
  databekabeling: 1,
  "verlichting-aanleggen": 2,
  "storing-verhelpen": 3,
  "krachtstroom-aanleggen": 0,
  "perilex-aansluiten": 0,
};

export function dienstFoto(dienstSlug: string, dienstNaam: string, plaatsNaam?: string) {
  const i = dienstIndex[dienstSlug] ?? hash(dienstSlug) % fotos.length;
  const foto = fotos[i]!;
  return {
    url: foto.url,
    alt: plaatsNaam
      ? `Erkende elektricien in ${plaatsNaam} bezig met ${dienstNaam.toLowerCase()}`
      : `Erkende elektricien bezig met ${dienstNaam.toLowerCase()}`,
  };
}
